import { useColorScheme, vars } from 'nativewind';
import { createContext, useContext, useMemo } from 'react';

import type { Mode } from './tokens';
import { buildThemeVars } from './tokens';

export const ThemeModeContext = createContext<Mode | null>(null);

export default function useThemeVars(modeOverride?: Mode) {
  const modeFromContext = useContext(ThemeModeContext);
  const { colorScheme } = useColorScheme();
  const mode: Mode = modeOverride ?? modeFromContext ?? (colorScheme === 'dark' ? 'dark' : 'light');
  return useMemo(() => vars(buildThemeVars(mode)), [mode]);
}
